const DECIMAL_BASE = 10

export function getComputedStyleValue(element: HTMLElement, property: string) {
    return parseInt(
        getComputedStyle(element).getPropertyValue(property),
        DECIMAL_BASE
    )
}
